<template>

  <div class="cookie" v-if="!acceptedCookies">
    <p>We use cookies to give you the best experience. A lot of our website couldn't function without cookies. If you have any issues, please notify us.</p>

    <button type="button" @click="acceptCookie">I accept</button>
  </div>

</template>
<script>
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      accepted: false
    }
  },
  computed: {
    acceptedCookies() {
      return (this.accepted || Cookies.get('phisharCookie')) ? true : false
    }
  },
  methods: {
    acceptCookie() {
      Cookies.set('phisharCookie', true)
      this.accepted = true
    }
  }
}
</script>
